import { useEffect, useState } from 'react'

export function useDebouncedValue(value, delayMs = 300) {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delayMs)
        return () => clearTimeout(t)
    }, [value, delayMs])

    return debounced
}


